/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imageGetAvatarGravatar } from "../../funcs/imageGetAvatarGravatar.js";
import { GetAvatarGravatarRequest$zodSchema } from "../../models/getavatargravatarop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetAvatarGravatarRequest$zodSchema.optional(),
};

export const tool$imageGetAvatarGravatar: ToolDefinition<typeof args> = {
  name: "image-get-avatar-gravatar",
  description: `获取Gravatar头像

提供一个超高速、高可用的Gravatar头像代理服务。内置了强大的ETag条件缓存，确保用户在更新Gravatar头像后能几乎立刻看到变化，同时最大化地利用缓存。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imageGetAvatarGravatar(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
